var map = {
	"./card_question_channel.js": 6,
	"./card_resource_channel.js": 7,
	"./chat_channel.js": 19,
	"./game_dice_channel.js": 8,
	"./game_player_session_channel.js": 9,
	"./game_player_table_channel.js": 10,
	"./game_player_table_selected_channel.js": 11,
	"./game_spreadsheet_channel.js": 20
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;